import { Component, OnInit, Input } from '@angular/core';
import { ProcessService } from '../../../../services/process.service';
import { Process } from '../../../../models/process-models';
import { EmployeeType } from '../../../../models/identity';


@Component({
  selector: 'app-appraisee',
  templateUrl: './appraisee.component.html',
  styleUrls: ['./appraisee.component.scss']
})
export class AppraiseeComponent implements OnInit {
  @Input() process: Process;
  isToggle: boolean = true;
  proffStaff: boolean;
  supporStaff: boolean;
  employeeType = EmployeeType;

  constructor(private processService: ProcessService) { }

  ngOnInit() {
    if (this.process.id) {
      this.setEmployeeTypes();
      return;
    }
    this.process.appraiseeSearchSettings = [];
    this.process.appraiseeEmployeeTypes = [];
  }

  toggleEmployeeType(employeeType: EmployeeType) {
    this.processService.toggleEnumSetting(this.process.appraiseeEmployeeTypes, employeeType);
    this.processService.onEmployeeTypeChanged();
  }

  private setEmployeeTypes() {
    this.proffStaff = this.getIndexByEmployeeType(EmployeeType.ProfessionalStaff) !== -1;
    this.supporStaff = this.getIndexByEmployeeType(EmployeeType.SupportStaff) !== -1;
  }

  private getIndexByEmployeeType(employeeType: EmployeeType) {
    return this.process.appraiseeEmployeeTypes.indexOf(employeeType);
  }
}